// import { parse } from '@fortawesome/fontawesome-svg-core';
import React, { useEffect, useState } from 'react'
import { Container, Col, Row, Button, Form, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IPUrl } from "../commons/IPAddress";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from "../commons/inFormTypes";
import axios from 'axios';
import Loaders from '../components/Loaders';

function FinalInfo() {
    const [snip, setSnip] = useState(false);
    const name = localStorage.getItem("user_namefamily");


    const mstr = JSON.parse(localStorage.getItem("Master"));

    const lstarray = JSON.parse(localStorage.getItem("Lstarray"));
    const userToken = localStorage.getItem("user_token");

    const navigate = useNavigate()

    useEffect(() => {

        if (userToken == null) {
            navigate("/");
        } else {
            if (mstr === null && lstarray === null)
                navigate("../dashboard")
        }
    }
        , [])

    const submitHandler = () => {

        console.log("ldetails" + localStorage.getItem("Lstarray"));
        console.log("lmaster" + localStorage.getItem("Master"));
        const axios = require("axios");
        setSnip(true);
        axios
            .post(apiUrl + "Insert_Orders", {
                ldetails: localStorage.getItem("Lstarray"),
                lmaster: localStorage.getItem("Master"),
                TokenId: userToken,
                Code_Meli: "",
            })

            .then((res) => {
                setSnip(false);
                if (res.data.result === "true") {
                    navigate("../dashboard")
                    localStorage.removeItem("Master");
                    localStorage.removeItem("Lstarray")
                    toast.success(res.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.error(res.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(error.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            });
    }



    return (

        <div>
            {lstarray !== null ?
                <Container>
                    <Row className="justify-content-center mb-3">
                        <Col xs={11} lg={9} className="mt-3">
                            <Row className="justify-content-center gy-3 gx-5">
                                <Col xs={12}>
                                    <div className="d-flex rgc-title">
                                        <div className="rgc-title-point"></div>
                                        <h4>اطلاعات <span>سفارش دهنده</span></h4>
                                    </div>
                                </Col>


                                <Col xs={12} className="rgc-driver-txt1">
                                    <Row className="justify-content-around  rgc-station-time">
                                        <Col xs={12} className="rgc-order-span">
                                            <span>نام و نام خانوادگی:</span>
                                            <span>{name}</span>
                                        </Col>
                                        <div className={mstr[0].deliveryId !== 5 ? "d-block" : "d-none"}>
                                            <Col xs={12} className="rgc-order-span">
                                                <span>آدرس:</span>
                                                <span>{mstr[0].address}</span>
                                            </Col>
                                        </div>
                                    </Row>
                                </Col>

                                <div className={mstr[0].deliveryId === 5 ? "d-block" : "d-none"}>
                                    <Col xs={12}>
                                        <div className="d-flex rgc-title">
                                            <div className="rgc-title-point"></div>
                                            <h4>اطلاعات <span>ایستگاه </span></h4>
                                        </div>
                                    </Col>

                                    <Col xs={12} className="rgc-driver-txt">
                                        <Row className="justify-content-around  rgc-station-time">
                                            <Col xs={12} className="rgc-order-span">
                                                <span> عنوان:</span>
                                                <span>{mstr[0].stationTitle}</span>
                                            </Col>

                                            <Col xs={12} className="rgc-order-span">
                                                <span>آدرس:</span>
                                                <span>{mstr[0].address} {mstr[0].stationAddress}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>


                                <Col xs={12}>
                                    <div className="d-flex rgc-title">
                                        <div className="rgc-title-point"></div>
                                        <h4>اطلاعات <span>سفارش </span></h4>
                                    </div>
                                </Col>

                                <Col xs={12} className="rgc-driver-txt rgc-station-time">
                                    <Row className="justify-content-around">

                                        <Col xs={12} md={6}>
                                            {lstarray.map((item, index) => {
                                                return (
                                                    <Row key={index} className="justify-content-around  rgc-station-time">

                                                        <Col xs={2}>
                                                            <Image src={IPUrl + item.icon} alt="" className="rgc-image" />
                                                        </Col>

                                                        <Col xs={10} className="text-end">
                                                            <div className='rgc-station-item'>
                                                                <span>{item.name}</span>
                                                            </div>
                                                        </Col>

                                                        <Col xs={6} className="text-center">
                                                          <span>وزن:</span>
                                                          <span>{item.count}{item.titleWeight} </span>
                                                        </Col>


                                                        <Col xs={6} className="rgc-order-span text-center">
                                                            <span>مبلغ:</span>
                                                            <span>{Intl.NumberFormat('en-US').format(item.Sum)}&nbsp; ریال</span>
                                                        </Col>

                                                    </Row>
                                                )
                                            }
                                            )}

                                        </Col>


                                        <Col xs={9} className="rgc-driver-txt text-center my-2">
                                            <hr />
                                            <div className="d-flex flex-column justify-content-center">
                                                <div className="rgc-order-span">
                                                    <span>مجموع مبالغ:</span>
                                                    <span>{Intl.NumberFormat('en-US').format(mstr[0].coint)}&nbsp;ریال</span>
                                                </div>

                                                <div className="rgc-order-span">
                                                    <span>مجموع وزن:</span>
                                                    <span>{mstr[0].weight}&nbsp;کیلوگرم</span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                <div className={mstr[0].deliveryId !== 5 ? "d-block" : "d-none"}>
                                    <Col xs={12}>
                                        <div className="d-flex rgc-title">
                                            <div className="rgc-title-point"></div>
                                            <h4>بازه زمانی <span>تحویل </span></h4>
                                        </div>
                                    </Col>

                                    <Col xs={12} className="rgc-station-time">
                                        <Row className="justify-content-center">

                                            <Col xs={5} md={5} className="rgc-order-span rgc-day text-center">
                                                {/* <span>نوع تحویل :</span> */}
                                                <span>{mstr[0].type}</span>
                                            </Col>

                                            <Col xs={7} md={5} className="text-center rgc-order-span rgc-day">
                                                <span>{mstr[0].day}</span>
                                            </Col>

                                            {/* <Col xs={4} className="rgc-order-span rgc-day">
                                                <span>  {mstr[0].date}</span>
                                            </Col> */}
                                        </Row>
                                    </Col>
                                </div>

                                <div className={mstr[0].deliveryId === 5 ? "d-block" : "d-none"}>
                                    <Col xs={12}>
                                        <div className="d-flex rgc-title">
                                            <div className="rgc-title-point"></div>
                                            <h4>نوع  <span>تحویل </span></h4>
                                        </div>
                                    </Col>

                                    <Col xs={12} className="text-center rgc-driver-txt rgc-station-time rgc-order-span rgc-day">
                                        <span>{mstr[0].type}</span>
                                    </Col>
                                </div>

                                <Col xs={7} md={4} className="text-center pt-4">
                                    <Button onClick={submitHandler} className="rgc-order-btns rgc-order-btn-sub" >
                                        <Loaders loads={snip} />
                                        ثبت نهایی
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                : navigate("../dashboard")
            }
        </div>


    )
}

export default FinalInfo